/**
 * Claw 服务 API 封装层
 *
 * 封装所有与 Claw 相关的 API 调用
 */

import { clawsCreateClawByCode } from '@/app/services/claw';

export { clawsGetMyClaws } from '@/app/services/claw';

/**
 * 通过邀请码创建 Claw 实例。
 * 不传 code 时按"付费用户直接开通"的语义请求。
 */
export const createClawByCode = (clawCode?: string) =>
  clawsCreateClawByCode({ body: clawCode ? { claw_code: clawCode } : {} });
